'use strict';

import {Component,Inject,Input} from 'ng-metadata/core';

import { SnippetService } from './snippet.service';
import {SearchService} from '../search.service';
//your imports go here
import {PrimoResponse} from '../../infra/dataStructures/PrimoResponses/doc.interfcae';
import {ConfigurationUtil} from '../../nddUtils/configurationUtil.service';

@Component({
directives:[], //directives you want to use in your directive
selector: 'prm-snippet',
templateUrl: 'components/search/snippet/snippet.html',
})


export class PrmSnippet{
    @Input() private record: PrimoResponse.IDoc;
    @Input() public displayMode : string;

    constructor(private snippetService : SnippetService,
                private  searchService: SearchService,
                private configurationUtil: ConfigurationUtil,
               @Inject('actionIcons') private actionIcons: Object
    ) {
    }
    
    public getSnippet() {
        let snippets = this.snippetService.snippets;
        //console.log(' getSnippet ' +JSON.stringify(snippets));
        if (snippets) {
            let recordid = this.record.pnx.control.recordid;
            //console.log(recordid);
            if (angular.isArray(recordid)) {
                recordid = recordid[0];
            }
            if(snippets[recordid]){
            	return snippets[recordid].trim();
            }
        }
    }
     isSuprima() {
        return this.configurationUtil.isSuprima();
    }
    
    public highlights(){
        if(!this.isSuprima()){
            let terms= this.searchService.highlightsService.highlights;
            return terms['termsUnion'];
        }else{
            let terms =  this.snippetService.highlights;
            return terms;
        }

   }
   isEmail(){
    if(this.displayMode ==='email')
        return true;
    
    return false; 
    }
}


// WEBPACK FOOTER //
// ./src/main/webapp/components/search/snippet/snippet.directive.ts